import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-angle-down',
  shadow: false,
})
export class CmsIconAngleDown {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        width={this.dataWidth}
        height={this.dataHeight}
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.99994 8.58779L1.70713 0.29295C1.31666 -0.0976226 0.683491 -0.0977005 0.292919 0.292776C-0.0976532 0.683252 -0.097731 1.31642 0.292745 1.70699L9.29275 10.7092C9.48801 10.9045 9.74397 11.0022 9.99993 11.0022C10.2559 11.0022 10.5119 10.9045 10.7071 10.7092L19.7071 1.70699C20.0976 1.31642 20.0975 0.683252 19.707 0.292776C19.3164 -0.0977005 18.6832 -0.0976226 18.2927 0.29295L9.99994 8.58779Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
